module.exports = __webpack_public_path__ + "static/media/stanley.66dc4822.mp3";